import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgOtpInputConfig } from 'ng-otp-input';
import axios, { Axios } from 'axios';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import firebase from 'firebase/compat/app';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-forget-password-page',
  templateUrl: './forget-password-page.component.html',
  styleUrls: ['./forget-password-page.component.css'],
})
export class ForgetPasswordPageComponent implements OnInit {
  mobileNumberForm!: FormGroup;
  confirmPasswordForm!: FormGroup;
  showOtpComponent = true;
  validated = false;
  reCaptchaVerifier: any;
  verificationCode: any;
  enterNewPassword = false;
  userId: any = '';
  phoneNo: any;
  newPasswordVisible = false;
  passwordVisible = false;
  loginConfirm = false;

  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '35px',
      height: '35px',
      fontSize: '22px',
    },
  };

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private fireAuth: AngularFireAuth,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    firebase.initializeApp(environment.firebase);

    this.validated = false;
    this.mobileNumberForm = this.fb.group({
      phoneNumber: ['', [Validators.required]],
    });

    this.confirmPasswordForm = this.fb.group({
      enteredPassword: ['', [Validators.required]],
      confirmedPassword: ['', [Validators.required]],
    });
  }

  validateMobileNumber() {
     var self = this;
    if (self.mobileNumberForm.valid) {
      self.loginConfirm = true;
      // console.log(this.mobileNumberForm.value);
      axios
        .post(environment.url + 'auth/forgot-password/', {
          phoneNo: self.mobileNumberForm.value.phoneNumber,
        })
        .then(function (response) {
          // console.log(response.data.data);
          if (response.data.data.userExists) {
            self.validated = true;
            self.enterNewPassword = false;
            self.userId = response.data.data.userId;
            self.otpRequest();
            this.loginConfirm = false;
          } else {
            self.toastr.error('User account does not exists!', '', {
              timeOut: 2500,
              positionClass: 'toast-top-center',
            });
            this.loginConfirm = false;
          }
        })
        .catch((error) => {
          console.log(error.response);
          
          this.loginConfirm = false;
        });
    } else {
      Object.values(this.mobileNumberForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  otpRequest() {
    this.reCaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'sign-in-button',
      { size: 'invisible' }
    );
    firebase
      .auth()
      .signInWithPhoneNumber(
        '+974' + this.mobileNumberForm.value.phoneNumber,
        this.reCaptchaVerifier
      )
      .then((confirmationResult) => {
        // console.log(confirmationResult);
        this.verificationCode = confirmationResult.verificationId;
        this.phoneNo = this.mobileNumberForm.value.phoneNumber;
        this.validated = true;
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  onOtpChange(event) {
    if (event.length == 6) {
      this.spinner.show();
      var credentials = firebase.auth.PhoneAuthProvider.credential(
        this.verificationCode,
        event
      );
      firebase
        .auth()
        .signInWithCredential(credentials)
        .then((response) => {
          // console.log(response);
          this.addNewPassword();
          this.spinner.hide();
        })
        .catch((error) => {
          alert(error.message);
          this.spinner.hide();
        });
    }
  }

  addNewPassword() {
    // alert('otp verified');

    this.enterNewPassword = true;
  }

  confirmPassword() {
    if (this.confirmPasswordForm.valid) {
      // console.log(this.confirmPasswordForm.value);
      if (
        this.confirmPasswordForm.value.confirmedPassword ==
        this.confirmPasswordForm.value.enteredPassword
      ) {
        axios
          .post(environment.url + 'auth/reset-password/', {
            password: this.confirmPasswordForm.value.enteredPassword,
            confirmPassword: this.confirmPasswordForm.value.confirmedPassword,
            userId: this.userId,
          })
          .then(function (response) {});
        this.toastr.success('Password Updated Successfully!', '', {
          timeOut: 2500,
          positionClass: 'toast-top-center',
        });
        this.router.navigate(['/']);
      } else {
        this.toastr.error('Password Mismatch!', '', {
          timeOut: 2500,
          positionClass: 'toast-top-center',
        });
      }
    } else {
      Object.values(this.confirmPasswordForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  resendOtp() {
    this.otpRequest();
  }
}
